import { render, staticRenderFns } from "./payline-combination-table.vue?vue&type=template&id=216a0e25&"
import script from "./payline-combination-table.vue?vue&type=script&lang=js&"
export * from "./payline-combination-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports